import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/ui/layout.js";
import DocPreviewExample from '~/examples/doc-preview';
import { SourceCode } from '~/ui';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`A simple component rendering any document supported by `}<inlineCode parentName="p">{`unified-doc`}</inlineCode>{`.  This example applies most of the core `}<inlineCode parentName="p">{`unified-doc`}</inlineCode>{` and `}<inlineCode parentName="p">{`unified-doc-dom`}</inlineCode>{` API methods, and is used throughout the documentation site to render documents.`}</p>
    <SourceCode source="examples/doc-preview" mdxType="SourceCode" />
    <h3 {...{
      "id": "features"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Render any documents supported by `}<inlineCode parentName="li">{`unified-doc`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Rendered document is enhanced by relevant plugins and web technologies (syntax highlighting and custom CSS).`}</li>
      <li parentName="ul">{`Search and jump to matched results with anchor links and apply a brief highlight effect.`}</li>
      <li parentName="ul">{`Preview document in various ways (compiled, text content, syntax tree).`}</li>
      <li parentName="ul">{`Save document in supported formats (source, `}<inlineCode parentName="li">{`.html`}</inlineCode>{`, `}<inlineCode parentName="li">{`.txt`}</inlineCode>{`, `}<inlineCode parentName="li">{`.md`}</inlineCode>{`).`}</li>
      <li parentName="ul">{`Create and manage bookmarks by making simple text selections in the rendered document.`}</li>
    </ul>
    <h3 {...{
      "id": "concepts"
    }}>{`Concepts`}</h3>
    <ul>
      <li parentName="ul">{`Apply custom `}<inlineCode parentName="li">{`mark`}</inlineCode>{` CSS.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`mark`}</inlineCode>{` anchorlinks.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`doc.compile()`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`doc.file()`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`doc.parse()`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`doc.search()`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`doc.textContent()`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`dom.highlight()`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`dom.registerMarks()`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`dom.selectText()`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`dom.saveFile()`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`options.marks`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`options.prePlugins`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`options.sanitizeSchema`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "demo"
    }}>{`Demo`}</h3>
    <DocPreviewExample mdxType="DocPreviewExample" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      